module.exports = __webpack_public_path__ + "static/media/piped_gas_2.7338f1e1.svg";